(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["batida-ux-enhancements"] && !Shopify.designMode) return;
  try {
    (() => {
  function initMap() {
    const app = document.getElementById('storePickupApp');
    const labels = document.getElementById('batida-ux-labels');
    if (!app || !labels || app.dataset.batidaMapToggleReady) return;
    app.dataset.batidaMapToggleReady = 'true';
    let expanded = false;
    let pending = false;
    function enhance() {
      pending = false;
      const map = app.querySelector('#zapietMap');
      if (!map || map.closest('.batida-map-panel')) return;
      const panel = document.createElement('div');
      panel.className = 'batida-map-panel';
      panel.id = 'batida-pickup-map-panel';
      const toggle = document.createElement('button');
      toggle.type = 'button';
      toggle.className = 'batida-map-toggle';
      toggle.setAttribute('aria-controls', panel.id);
      map.before(toggle, panel);
      panel.append(map);
      function sync() {
        toggle.setAttribute('aria-expanded', String(expanded));
        toggle.textContent = expanded ? labels.dataset.hideMap : labels.dataset.showMap;
        panel.toggleAttribute('data-collapsed', !expanded);
        panel.inert = !expanded;
      }
      toggle.addEventListener('click', () => { expanded = !expanded; sync(); });
      sync();
    }
    new MutationObserver(() => {
      if (!pending) { pending = true; requestAnimationFrame(enhance); }
    }).observe(app, { childList: true, subtree: true });
    enhance();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initMap, { once: true });
  else initMap();
  document.addEventListener('shopify:section:load', initMap);
})();
  } catch(e) { console.error(e); }
})();

})();
